function LegalPage({ title, intro, children }) {
  return (
    <article className="legal-page">
      <header className="legal-hero">
        <h1>{title}</h1>
        <p>{intro}</p>
      </header>
      <div className="legal-content">{children}</div>
    </article>
  );
}

export default LegalPage;
